module.exports = __webpack_public_path__ + "static/media/logoWh.699632e8.png";